export default __webpack_public_path__ + "static/media/relaxing_at_home.cc1babf4.svg";